import newVue from '../main'
import axios from "axios"
import qs from "qs" // 序列化请求数据
import { showToast, setCookie, returnFormData } from "../common/js/assist"
var baseUrl = '';
if(process.env.NODE_ENV == 'development') {
	//无用户版
	baseUrl = "https://saastest.hdwbcloud.com/api"
	//有用户版
	baseUrl = "https://saas.hdwbcloud.com/api"
} else if(process.env.NODE_ENV == 'production') {
	baseUrl = BASEURL + '/api'
}
const axios_instance = axios.create({
	// 基础url前缀
	baseURL: baseUrl,
	// 请求头信息
	headers: {
		"Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
		Accept: "application/json"
	},
	// 设置超时时间
	timeout: 20000,
	// 携带凭证
	// 返回数据类型
	responseType: "json",
});
// 添加请求拦截器
axios_instance.interceptors.request.use(config => {
	// 在发送请求之前做些什么
	return config;
}, error => {
	// 对请求错误做些什么
	newVue.$store.commit('request_error', true);
	//showToast('请求异常，请刷新重试');
	return Promise.reject(error)
});
// 添加响应拦截器
axios_instance.interceptors.response.use(
	response => {
		if(![1, 9001, 9002].includes(response.data.status)) {
			if(response.data.status == 405) {
				showToast('登录已失效');
				localStorage.clear();
				if(response.config.type == 'personal') {
					newVue.$store.commit('personal_user_info', JSON.parse(localStorage.getItem('personal_user_info')) || {});
					if(JSON.parse(sessionStorage.getItem('base_info')).pc_login_show.length == 2) {
						//微信扫码登录&&邮箱验证码登录
					} else {
						if(JSON.parse(sessionStorage.getItem('base_info')).pc_login_show.includes('11')) {
							//微信扫码登录
							setCookie('wx_scan_rurl', window.location.href, 5);
							window.location.href = WX_OAUTH_URL + '/wx_oauth_w'
						} else {
							//邮箱验证码登录
							newVue.$store.commit('show_login', true)
						}
					}
				} else if(response.config.type == 'team') {
					newVue.$store.commit('team_login_info', JSON.parse(localStorage.getItem('team_login_info')) || {});
					newVue.$store.commit('show_team_login', true)
				}
			} else if(response.data.status == 0) {
				showToast(response.data.msg);
			}
		} else {
			return response.data
		}
	},
	error => {
		newVue.$store.commit('request_error', true)
	}
);
export default function(url = "", data = {}, type = "GET", otherConfig = {}) {
	type = type.toUpperCase();
	return new Promise((resolve, reject) => {
		if(type === "GET") {
			var options = {
				url: url,
				method: "get",
				params: data
			}
		} else if(type === "POST") {
			var options = {
				url: url,
				method: "post",
				data: otherConfig.formData ? returnFormData(data) : qs.stringify(data)
			}
		}
		axios_instance({
				...options,
				...otherConfig
			})
			.then(res => {
				if(res) {
					resolve(res)
				} else {
					reject()
				}
			})
			.catch(err => {
				reject(err);
			})
	})
}


// WEBPACK FOOTER //
// ./src/http/api.js